import { Box } from '@mui/material';

function AuthHeader() {
  return <Box className="auth-header-container"></Box>;
}

export default AuthHeader;
